import i18n from "i18n";
import { FilterType } from "components/Reports/reportAssets/assets";
import { savedFilterType } from "components/SavedFIlters/savedFilter.types";
import { filterOption } from "models/filterOption";

const typeofValue = (options, value) => {
  const num = !Number.isNaN(options[1]) ? options[0] : options[1];
  const string = !Number.isNaN(options[1]) ? options[1] : options[0];

  if (value === "label") {
    return string;
  }
  return num;
};

export const optionsSelectInFormHandler = (enumObj) => {
  const options = Object.entries(enumObj);
  return options.map((option) => {
    return {
      label: i18n.t(typeofValue(option, "label") as string),
      value: Number(typeofValue(option, "value")),
    };
  });
};

export type MultiSelectProps = {
  reportDate?: Date;
  setReportDate?: React.Dispatch<React.SetStateAction<Date>>;
  updateDate?: Date;
  setUpdateDate?: React.Dispatch<React.SetStateAction<Date>>;
  registrationDate?: Date;
  setRegistrationDate?: React.Dispatch<React.SetStateAction<Date>>;
  lastReportUpdate?: Date;
  setLastReportUpdate?: React.Dispatch<React.SetStateAction<Date>>;
  filtersOptions: filterOption;
  setFiltersOptions: (prev: any) => void;
  filterOptionInit: () => void;
  runFilter?: boolean;
  setRunFilter?: (prev: boolean) => void;
  setChosenFilter?: React.Dispatch<
    React.SetStateAction<object | savedFilterType>
  >;
  chosenFilter?: savedFilterType;
  filterType: FilterType;
  dbRequest;
  submitFilter?;
  filterOptionsObject: filterOption;
};
